module.exports = __webpack_public_path__ + "static/img/zp0-D5GlfLLc.c2f2528.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/zp0-D5GlfLLc.png
// module id = RxIL
// module chunks = 16